import cx from 'classnames';
import * as React from 'react';
import CurrentUser from 'auth/CurrentUser';
import TranslatableText from 'chat/components/TranslatableText';
import LinkPreviewContainer from 'chat/components/Stream/components/LinkPreviewsContainer/LinkPreviewContainer';
import Attachments from 'chat/components/_shared/Attachments/Attachments';

import './MessageItemBody.scss';

export type Props = {
  item: {
    locale: string;
    body: string;
    files: any;
    sender: {
      uuid: string;
    };
    translationDetails: {
      originalText: string;
    };
    linkPreviews: any;
  };
  showOriginal?: boolean;
};

type State = {
  locale: string | undefined | null;
};

class MessageItemBody extends React.Component<Props, State> {
  state: State = {
    locale: this.props.item.locale,
  };

  static defaultProps = {
    showOriginal: false,
  };

  shouldComponentUpdate(nextProps: Props, nextState: State) {
    return (
      this.state.locale !== nextState.locale ||
      this.props.showOriginal !== nextProps.showOriginal ||
      this.props.item.body !== nextProps.item.body ||
      this.props.item.locale !== nextProps.item.locale
    );
  }

  isAuthor() {
    return CurrentUser.isSignedIn() && CurrentUser.getUserUuid() === this.props.item.sender.uuid;
  }

  isTranslatable = () => {
    return (
      this.props.item.locale &&
      CurrentUser.isSignedIn() &&
      CurrentUser.getUser().getISO639Locale() &&
      CurrentUser.getUser().getISO639Locale() !== this.props.item.locale &&
      !this.isAuthor()
    );
  };

  hasAttachments = () => {
    const { files } = this.props.item;
    return Array.isArray(files) && files.length > 0;
  };

  translate = () => {
    if (this.state.locale === this.props.item.locale) {
      this.setState({ locale: CurrentUser.getUser().getISO639Locale() });
    } else {
      this.setState({ locale: this.props.item.locale });
    }
  };

  renderBody() {
    if (!this.props.item.body) {
      return null;
    }

    const { body, translationDetails } = this.props.item;
    let message = body;
    if (this.props.showOriginal && translationDetails) {
      message = translationDetails.originalText;
    }

    return (
      <div
        onClick={this.isTranslatable() ? this.translate : undefined}
        data-test-selector="translatable-message-item-body"
        className={cx('MessageItemBody-body', {
          'MessageItemBody-body-translatable': this.isTranslatable(),
          'MessageItemBody-body-bottom': !this.hasAttachments(),
        })}
      >
        {/* @ts-expect-error ts-migrate(2322) FIXME: Type 'string | null | undefined' is not assignable... Remove this comment to see the full error message */}
        <TranslatableText initialText={message} language={this.state.locale} />
      </div>
    );
  }

  renderAttachment() {
    const { files } = this.props.item;

    if (!this.hasAttachments()) {
      return null;
    }

    return <Attachments files={files} />;
  }

  renderLinkPreviews() {
    if (!Array.isArray(this.props.item.linkPreviews)) {
      return null;
    }

    const { linkPreviews } = this.props.item;

    if (linkPreviews.length <= 0) {
      return null;
    }

    return (
      <div className="MessageItemBody-linkPreviews">
        <LinkPreviewContainer linkPreviews={linkPreviews} />
      </div>
    );
  }

  render() {
    return (
      <div className={cx({ 'MessageItemBody-self': this.isAuthor() })}>
        {this.renderBody()}
        {this.renderAttachment()}
        {this.renderLinkPreviews()}
      </div>
    );
  }
}

export default MessageItemBody;
